import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const WarnIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
            d="M12 6v8m.05 4v.1h-.1V18h.1Z"/>
    </SvgIcon>
  );
};

